import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import api from "services/api";
import { requireAuth } from "actions/AuthAction";

function DaftarLayanan() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [layanan, setLayanan] = useState([]);

  useEffect(() => {
    const user = requireAuth(navigate, ["PEMOHON"]);
    if (!user) return;

    api
      .get("jenis-izin?status=AKTIF")
      .then((res) => setLayanan(res.data?.data || []))
      .catch(() => alert("Gagal memuat daftar layanan"))
      .finally(() => setLoading(false));
  }, [navigate]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <MDTypography variant="h4" fontWeight="medium">
            Pilih Layanan
          </MDTypography>
          <MDTypography variant="button" color="text">
            15 jenis layanan perizinan dan nonperizinan Kabupaten Rote Ndao
          </MDTypography>
        </MDBox>

        <Grid container spacing={3}>
          {loading && (
            <Grid item xs={12}>
              <MDTypography>Memuat layanan...</MDTypography>
            </Grid>
          )}
          {!loading &&
            layanan.map((item) => (
              <Grid item xs={12} md={6} lg={4} key={item.id}>
                <Card sx={{ height: "100%" }}>
                  <MDBox p={3} display="flex" flexDirection="column" height="100%">
                    <MDBox mb={1}>
                      <Chip label={item.sektor} size="small" color="info" variant="outlined" />
                    </MDBox>
                    <MDTypography variant="h6" fontWeight="medium" mb={1}>
                      {item.nama}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" mb={1}>
                      Kode: {item.kode} • {item.kategori}
                    </MDTypography>
                    <MDTypography variant="button" color="text" mb={2}>
                      Waktu layanan: {item.waktu_layanan || "1 Jam"}
                    </MDTypography>
                    <MDBox mt="auto">
                      <MDButton
                        variant="gradient"
                        color="info"
                        fullWidth
                        onClick={() => navigate(`/layanan/${item.id}`)}
                      >
                        Lihat Persyaratan
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DaftarLayanan;
